function openWarrantyCheckModal() {
  const modal = document.getElementById('warrantyCheckModal');
  if (!modal) return;
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  clearWarrantyCheck();
}

function closeWarrantyCheckModal() {
  const modal = document.getElementById('warrantyCheckModal');
  if (!modal) return;
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

function closeWarrantyCheckModalOnBackdrop(event) {
  if (event.target.id === 'warrantyCheckModal') {
    closeWarrantyCheckModal();
  }
}

function clearWarrantyCheck() {
  const input = document.getElementById('warrantyCheckInput');
  const content = document.getElementById('warrantyCheckResultContent');
  const loader = document.getElementById('warrantyCheckLoader');
  if (input) input.value = '';
  if (loader) {
    loader.style.display = 'none';
  }
  if (content) {
    content.style.display = 'block';
    content.innerHTML = '<div style="font-size: 1.2rem; text-align:center;padding:8px;color:#94a3b8;">Enter an IMEI and click Search</div>';
  }
}

function isValidWarrantyCheckImei(imei) {
  return /^[0-9]{15}$/.test(imei);
}

function formatWarrantyCheckDate(dateStr) {
  if (!dateStr) return 'Not available';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short'
  });
}

function showWarrantyCheckLoader() {
  const loader = document.getElementById('warrantyCheckLoader');
  const content = document.getElementById('warrantyCheckResultContent');
  if (loader) {
    loader.style.display = 'block';
  }
  if (content) {
    content.style.display = 'none';
  }
}

function hideWarrantyCheckLoader() {
  const loader = document.getElementById('warrantyCheckLoader');
  const content = document.getElementById('warrantyCheckResultContent');
  if (loader) {
    loader.style.display = 'none';
  }
  if (content) {
    content.style.display = 'block';
  }
}

async function searchWarrantyCheck() {
  const input = document.getElementById('warrantyCheckInput');
  const content = document.getElementById('warrantyCheckResultContent');
  if (!input || !content) {
    console.error('Required elements not found');
    return;
  }
  const imei = input.value.trim();
  if (!imei) {
    content.style.display = 'block';
    content.innerHTML = '<div class="warrantyCheckError">Please enter an IMEI number.</div>';
    return;
  }
  if (!isValidWarrantyCheckImei(imei)) {
    content.style.display = 'block';
    content.innerHTML = '<div class="warrantyCheckError">IMEI must be exactly 15 digits.</div>';
    return;
  }
  showWarrantyCheckLoader();  
  try {
    const response = await fetch(
      `https://faywa.toheedsoft.com/api/SearchIMEI/Search?imei=${imei}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    await new Promise(resolve => setTimeout(resolve, 500));
    hideWarrantyCheckLoader();
    content.innerHTML = `
      <div class="warrantyCheckResultCard">
        <p><strong>Model:</strong> <span>${data.model || 'N/A'}</span></p><hr>
        <p><strong>IMEI:</strong> <span>${data.imei || imei}</span></p><hr>
        <p><strong>Warranty Start:</strong> <span>${formatWarrantyCheckDate(data.warranty_Start)}</span></p><hr>
        <p><strong>Warranty End:</strong> <span>${formatWarrantyCheckDate(data.warranty_End)}</span></p>
      </div>
    `;
  } catch (error) {
    console.error('Search error:', error);
    hideWarrantyCheckLoader();
    content.innerHTML = `
      <div class="warrantyCheckError">
        Sorry! Record Not Found
      </div>
    `;
  }
}

document.addEventListener('keydown', function (e) {
  if (e.target && e.target.id === 'warrantyCheckInput' && e.key === 'Enter') {
    e.preventDefault();
    searchWarrantyCheck();
  }
});

window.openWarrantyCheckModal = openWarrantyCheckModal;
window.closeWarrantyCheckModal = closeWarrantyCheckModal;
window.closeWarrantyCheckModalOnBackdrop = closeWarrantyCheckModalOnBackdrop;
window.searchWarrantyCheck = searchWarrantyCheck;
window.clearWarrantyCheck = clearWarrantyCheck;

if (window.location.hash === '#warrantyCheck') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openWarrantyCheckModal);
  } else {
    openWarrantyCheckModal();
  }
}

document.addEventListener('click', function(event) {
  const link = event.target.closest('a[href="#warrantyCheck"]');
  if (link) {
    event.preventDefault();
    openWarrantyCheckModal();
  }
});